import { getAttribute, type ScriptParams } from '../getScriptParams.tsx';
import type { PluginTypePluginParams } from './PluginTypeParams.ts';

type GetPluginTypePluginParamsArgs = {
  node: Element;
  projectType: string;
  scriptParams?: Partial<ScriptParams>;
};

export const getPluginTypePluginParams = ({
  node,
  projectType,
  scriptParams,
}: GetPluginTypePluginParamsArgs): PluginTypePluginParams => {
  const appID = getAttribute(node, 'data-appid') || scriptParams?.appID;
  const correlationID =
    getAttribute(node, 'data-correlationID') || scriptParams?.correlationID;

  const paymentLinkID =
    getAttribute(node, 'data-paymentLinkID') || scriptParams?.paymentLinkID;

  const isTemp = !!scriptParams?.isTemp;

  return {
    appID,
    correlationID,
    paymentLinkID,
    projectType,
    isTemp,
  };
};
